const outlinedButtonSx = {
  borderRadius: '12px',
  borderColor: '#DED8D7',
  color: '#2D2925',
  backgroundColor: 'white',
  paddingBlock: {xs: '12px', sm: '16px'},
  paddingInline: {xs: '16px', sm: '20px'},
  fontWeight: 500,
  fontSize: '16px',
  lineHeight: '150%',
  textTransform: 'none',
  width: {xs: '100%', sm: 'auto'},
};

const primaryButtonSx = {
  'borderRadius': '12px',
  'color': 'white',
  'backgroundColor': '#DA7955',
  'paddingBlock': {xs: '12px', sm: '16px'},
  'paddingInline': {xs: '16px', sm: '20px'},
  'fontWeight': 500,
  'fontSize': '16px',
  'lineHeight': '150%',
  'boxShadow': 'none',
  'textTransform': 'none',
  'width': {xs: '100%', sm: 'auto'},
  '&:hover': {
    backgroundColor: '#DA7955',
    boxShadow: 'none',
  },
};

export {
  outlinedButtonSx,
  primaryButtonSx,
};
